import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { BankAccount, BankAccountTypeEnum } from 'taxtank-core';

/**
 * UI Component: box with main bank account information
 */
@Component({
  selector: 'app-bank-account-preview-card',
  templateUrl: './bank-account-preview-card.component.html',
  styleUrls: ['./bank-account-preview-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BankAccountPreviewCardComponent {
  @Input() bankAccount: BankAccount;
  @Input() isActive = false;
  bankAccountTypes: typeof BankAccountTypeEnum = BankAccountTypeEnum;
}
